import API from '@/api';
// import hasPermission from '../../utils/hasPermission';
// import { groupPermissions } from '../../utils/licenseDetails';

const GET_DATA = 'GET_DATA';
const GET_DATA_FAILED = 'GET_DATA_FAILED';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';

// Enabled the module to be namespaced
const namespaced = true;

const state = {
  loading: false,
};

const getters = {
  isLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  // * Partner gets a specific partner based on user token
  async apiPartnerForUser({ commit }) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.trusimpartners.apiPartnerForUser();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerPromote promotes partner status
  async apiPartnerPromote({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.trusimpartners.apiPartnerPromote(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerNotifyProd triggers email notification of ready to release
  async apiPartnerNotifyProd({ commit }) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.trusimpartners.apiPartnerNotifyProd();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerUpdate a specific partner's product list
  async apiPartnerUpdate({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.trusimpartners.apiPartnerUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerRequestLicenses a specific partner's product list
  async apiPartnerRequestLicenses({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.trusimpartners.apiPartnerRequestLicenses(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
};

// @ MUTATIONS ====================================================================
const mutations = {
  [GET_DATA](state) {
    state.loading = true;
  },

  [GET_DATA_FAILED](state) {
    state.loading = false;
  },

  [GET_DATA_SUCCESS](state, data) {
    state.loading = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
